import Vue from 'vue';
import '@/assets/stylesheets/main.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'element-theme-default/lib/index.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import BlockUI from 'vue-blockui';
import HighchartsVue from 'highcharts-vue';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueRangeDatePicker from 'vue-rangedate-picker';
import VueMonthlyPicker from 'vue-monthly-picker';
import DateRangePicker from 'vue2-daterange-picker';
import clevertap from 'clevertap-web-sdk';
// set language to EN
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

// import DataTables and DataTablesServer together
import VueDataTables from 'vue-data-tables';

// eslint-disable-next-line no-unused-vars
import Vuelidate from 'vuelidate';

import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTasks,
  faUser,
  faEnvelope,
  faSpinner,
  faMusic,
  faChartLine,
  faWallet,
  faUsers,
  faDrum,
  faAngleRight,
  faTimes,
  faTrashAlt,
  faSync,
  faFileContract,
  faTimesCircle,
  faArrowDown,
  faArrowUp,
  faEye,
  faPencilAlt,
  faFileAlt,
  faCheck,
  faBan,
  faCircle,
  faCircleNotch,
  faChartBar,
  faMoneyBill,
  faEnvelopeSquare,
  faAddressBook,
  faDollarSign,
  faClipboardList,
  faEyeSlash
  ,
  faTags,
  faUpload,
  faCloudUploadAlt,
  faTrash,
  faCogs,
  faTh,
  faPlus,
  faPlayCircle,
  faStar,
  faFileVideo,
  faArrowLeft, faChevronLeft, faListUl,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App';
import router from './router';

import store from './stores';
import vClickOutside from 'v-click-outside';
import VueFormWizard from 'vue-form-wizard';

import VueTimepicker from 'vue2-timepicker';
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';

clevertap.setLogLevel(0);
clevertap.privacy.push({ optOut: true }); // Set the flag to true, if the user of the device opts out of sharing their data
clevertap.privacy.push({ useIP: false }); // Set the flag to true, if the user agrees to share their IP data
clevertap.spa = true;
clevertap.init(process.env.CLEVERTAP_ACCOUNT_ID, 'eu1');

Vue.use(VueDataTables);
Vue.use(CKEditor);
Vue.use(BlockUI);
Vue.use(VueSweetalert2);
Vue.use(HighchartsVue);
Vue.use(VueMonthlyPicker);
Vue.use(DateRangePicker);
Vue.use(vClickOutside);
Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 12,
  fontWeight: 400,
  zIndex: 10000,
});


// eslint-disable-next-line max-len
library.add(
  faTasks,
  faUser,
  faEnvelope,
  faSpinner,
  faMusic,
  faChartLine,
  faWallet,
  faUsers,
  faDrum,
  faAngleRight,
  faTimes,
  faTrashAlt,
  faSync,
  faFileContract,
  faTimesCircle,
  faArrowDown,
  faArrowUp,
  faEye,
  faPencilAlt,
  faFileAlt,
  faCheck,
  faBan,
  faCircleNotch,
  faChartBar,
  faMoneyBill,
  faEnvelopeSquare,
  faAddressBook,
  faDollarSign,
  faClipboardList,
  faEyeSlash,
  faTags,
  faUpload,
  faCloudUploadAlt,
  faTrash,
  faCogs,
  faTh,
  faPlus,
  faPlayCircle,
  faStar,
  faFileVideo,
  faArrowLeft,
  faChevronLeft,
  faListUl,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
locale.use(lang);
Vue.use(ElementUI);
Vue.use(VueFormWizard);

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    toDollar(credit = 0) {
      const creditDollar = credit / 10;
      if (creditDollar % 1 !== 0) {
        return Number(this.toFixed(creditDollar, 2));
      }
      return parseInt(creditDollar);
    },
    toCredit(dollar = 0) {
      return parseFloat(dollar * 10);
    },
    toFixed(num, fixed) {
      const re = new RegExp(`^-?\\d+(?:\.\\d{0,${fixed || -1}})?`);
      return num.toString().match(re)[0];
    },
    toggleDashboardProfile(state = null) {
      // const dropdown = document.getElementById('myDropdown');
      // if (state !== null) {
      //   dropdown.style.display = state ? 'block' : 'none';
      // } else {
      //   const display = dropdown.style.display;
      //   if (display === 'block') {
      //     dropdown.style.display = 'none';
      //   } else {
      //     dropdown.style.display = 'block';
      //   }
      // }
    },
  },
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js